var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",staticStyle:{"margin-top":"10%","margin-bottom":"10%"}},[_c('div',{staticClass:"text-center block"},[_c('img',{staticClass:"mw-100",attrs:{"src":require("@/assets/images/selectedoffers/offer3.jpg"),"alt":""}})])])
}]

export { render, staticRenderFns }